var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"return-button",attrs:{"to":"/"}},[_c('span',{staticClass:"return-button-text"},[_vm._v("В галерею")])])}
var staticRenderFns = []

export { render, staticRenderFns }